var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 68,
    viewBox: "0 0 151 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 29.5C2.51472 29.5 0.5 31.5147 0.5 34C0.5 36.4853 2.51472 38.5 5 38.5L5 29.5ZM149.182 37.182C150.939 35.4246 150.939 32.5754 149.182 30.818L120.544 2.1802C118.787 0.422844 115.938 0.422844 114.18 2.1802C112.423 3.93756 112.423 6.7868 114.18 8.54416L139.636 34L114.18 59.4559C112.423 61.2132 112.423 64.0625 114.18 65.8198C115.938 67.5772 118.787 67.5772 120.544 65.8198L149.182 37.182ZM5 38.5L146 38.5L146 29.5L5 29.5L5 38.5Z",
    fill: "url(#paint0_linear_785_1242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_785_1242",
    x1: 75.5002,
    y1: 33.9999,
    x2: 117.3,
    y2: 108.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9CFB",
    stopOpacity: 0.35
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeArrow);
export default __webpack_public_path__ + "static/media/HomeArrow.081c0d5749a318fd6506f3c7760d961e.svg";
export { ForwardRef as ReactComponent };